<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.group_id == 1 ||
        has_perm('create_register_export_invoice') ||
        has_perm('update_register_export_invoice')
    "
  >
    <div>
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            <span>{{
              $t(
                registerExportInvoiceData.id === 0
                  ? "registerExportInvoice.addNewRegisterExportInvoice"
                  : "registerExportInvoice.registerExportInvoiceDetail"
              )
            }}</span>
          </h3>
        </div>

        <div class="box-body">
          <form class="form-horizontal">
            <div class="col-md-12">
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-2 col-md-2 col-lg-2 control-label required"
                  >
                    {{ $t("registerExportInvoice.apartmentCode") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <v-select
                      :disabled="registerExportInvoiceData.id !== 0"
                      class="clear"
                      :filter="fuseSearch"
                      :options="apartmentList"
                      v-model="registerExportInvoiceData.apartmentCode"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.text)"
                      :placeholder="$t('registerExportInvoice.apartmentCode')"
                    >
                      <template v-slot:option="option">
                        {{ option.text }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 mt-3 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-2 col-md-2 col-lg-2 control-label required"
                  >
                    {{ $t("registerExportInvoice.invoiceServiceType") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <v-select
                      class="clear"
                      multiple
                      :options="serviceList"
                      v-model="registerExportInvoiceData.invoiceServiceType"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.text)"
                    >
                      <template v-slot:option="option">
                        {{ $t(option.text) }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 mt-3 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-2 col-md-2 col-lg-2 control-label required"
                  >
                    {{
                      $t("registerExportInvoice.companyOrPersonalName")
                    }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeHolder="
                        $t('registerExportInvoice.companyOrPersonalName')
                      "
                      v-model="registerExportInvoiceData.companyOrPersonalName"
                    />
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-2 col-md-2 col-lg-2 control-label required"
                  >
                    {{ $t("registerExportInvoice.address") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeHolder="$t('registerExportInvoice.address')"
                      v-model="registerExportInvoiceData.address"
                    />
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-2 col-md-2 col-lg-2 control-label required"
                  >
                    {{ $t("registerExportInvoice.phone") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeHolder="$t('registerExportInvoice.phone')"
                      v-model="registerExportInvoiceData.phone"
                    />
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label class="col-sm-2 col-md-2 col-lg-2 control-label">
                    {{ $t("registerExportInvoice.email") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <input
                      type="email"
                      class="form-control"
                      :placeHolder="$t('registerExportInvoice.email')"
                      v-model="registerExportInvoiceData.email"
                    />
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label class="col-sm-2 col-md-2 col-lg-2 control-label">
                    {{ $t("registerExportInvoice.taxCode") }}</label
                  >
                  <div class="col-sm-10 col-md-10 col-lg-10">
                    <input
                      type="text"
                      class="form-control"
                      :placeHolder="$t('registerExportInvoice.taxCode')"
                      v-model="registerExportInvoiceData.taxCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="callbackList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            v-if="
              (GET_ACCOUNT_DATA.group_id == 1 ||
                has_perm('create_register_export_invoice') ||
                has_perm('update_register_export_invoice')) && !registerExportInvoiceData.isDeleted
            "
            class="btn btn-labeled btn-success pull-right"
            @click="onSaveRegisterExportInvoice"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import constantsData from "@/lib/constantsData";

export default {
  name: "CaseAdd",
  data() {
    return {
      isLoading: false,
      apartmentList: [],
      serviceList: constantsData.serviceList,
      registerExportInvoiceData: {
        id: 0,
        apartmentCode: null,
        companyOrPersonalName: null,
        invoiceServiceType: null,
        address: null,
        phone: null,
        email: null,
        taxCode: null,
        isDeleted: false
      }
    };
  },

  watch: {
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code
        };
        this.apartmentList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_NO_PAGE_DATA"
    ])
  },

  methods: {
    callbackList: function() {
      this.$router.push({
        name: "UserRegisterExportInvoice"
      });
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    fuseSearch(options, search) {
      let resultSearch = options.filter(x =>
        x.text.toLowerCase().includes(search.toLowerCase())
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    validateData: function() {
      let validateResults = "OK";
      for (let key in this.registerExportInvoiceData) {
        if (key === "taxCode") {
          //
        } else if (key === "email") {
          if (!utils.isEmptyString(this.registerExportInvoiceData[key])) {
            if (!utils.validateEmailAddress(this.registerExportInvoiceData[key])) {
              validateResults = this.$t("common.error_msg[2].email_invalidate");
              break;
            }
          }
        } else if (utils.isEmptyString(this.registerExportInvoiceData[key])) {
          validateResults = this.$t("registerExportInvoice." + key);
          break;
        } else if (
          key === "phone" &&
          !utils.validatePhone(this.registerExportInvoiceData[key])
        ) {
          validateResults = this.$t("common.error_msg[3].phone_invalidate");
          break;
        }
      }
      return validateResults;
    },
    onSaveRegisterExportInvoice: function() {
      let result = this.validateData();
      if (result === "OK") {
        this.isLoading = true;
        let data = {
          id: this.registerExportInvoiceData.id,
          apartmentId: this.registerExportInvoiceData.apartmentCode,
          serviceSelect: this.registerExportInvoiceData.invoiceServiceType,
          companyOrPersonalName: this.registerExportInvoiceData.companyOrPersonalName,
          address: this.registerExportInvoiceData.address,
          phone: this.registerExportInvoiceData.phone,
          email: this.registerExportInvoiceData.email,
          taxCode: this.registerExportInvoiceData.taxCode
        };
        if (this.registerExportInvoiceData.id === 0 ){
          this.CREATE_REGISTER_EXPORT_INVOICE(data)
          .then(
            function() {
              this.isLoading = false;
              this.callbackList();
            }.bind(this)
          )
          .catch(
            function() {
              this.isLoading = false;
            }.bind(this)
          );
        } else {
          this.UPDATE_REGISTER_EXPORT_INVOICE(data)
          .then(
            function() {
              this.isLoading = false;
              this.callbackList();
            }.bind(this)
          )
          .catch(
            function() {
              this.isLoading = false;
            }.bind(this)
          );
        }
      } else {
        this.showError(result);
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_APARTMENT_LIST",
      "CREATE_REGISTER_EXPORT_INVOICE",
      "UPDATE_REGISTER_EXPORT_INVOICE",
      "GET_REGISTER_EXPORT_INVOICE_DETAIL"
    ])
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  mounted() {
    // //////////////////////////////
    // Add or Update data
    // //////////////////////////////
    //  get apartment list
    let apartmentFilter = {
      params: {
        asset: "asset"
      }
    };
    this.isLoading = true;
    this.GET_APARTMENT_LIST(apartmentFilter)
      .then(
        function() {
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.GET_REGISTER_EXPORT_INVOICE_DETAIL({ id: id }).then(
          function(res) {
            let data = res;
            this.registerExportInvoiceData.id = data.id;
            this.registerExportInvoiceData.apartmentCode = data.apartment;

            this.registerExportInvoiceData.companyOrPersonalName =
              data.company_or_personal_name;
            this.registerExportInvoiceData.address = data.address;
            this.registerExportInvoiceData.phone = data.phone;
            this.registerExportInvoiceData.email = data.email;
            this.registerExportInvoiceData.taxCode = data.tax_code;
            this.registerExportInvoiceData.invoiceServiceType = data.service_list;
            this.registerExportInvoiceData.isDeleted = data.is_deleted
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr.new1 {
  width: 90%;
}

.date-format {
  padding-top: 7px;
  margin-bottom: 0;
}

.date-input-format {
  width: 304px;
}

/* label.required:not(:empty):after, */
/* .field-header.required:after { */
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  /* top: -5px; */
}

/* .margin-bottom-15 {
  padding-bottom: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/views/Invoice/UserRegisterExportInvoiceAdd.vue